import { NavigateAction, View, Views } from 'react-big-calendar'
import { translate } from '../../../../../I18n/i18n'
import { useTranslation } from 'react-i18next'
import { Spinner } from '@cuatroochenta/co-admin-react-library'
import './CustomToolbar.scss'

interface CustomToolbarProps {
    label: string
    onNavigate: (action: NavigateAction) => void
    view: View
    onViewChange: (view: View) => void
    onCreate: () => void
    loading: boolean
}

export default function CustomToolbar({
    label,
    onNavigate,
    view,
    onViewChange,
    onCreate,
    loading
}: CustomToolbarProps) {
    const { t } = useTranslation()

    return (
        <div className='calendar-toolbar'>
            <div className='navigation-bar'>
                <button onClick={() => onNavigate('TODAY')}>
                    {translate(t, 'calendar.TR_TODAY_LABEL')}
                </button>
                <div className='navigation-arrows'>
                    <button onClick={() => onNavigate('PREV')}>
                        <i className='fa fa-chevron-left'></i>
                    </button>
                    <button onClick={() => onNavigate('NEXT')}>
                        <i className='fa fa-chevron-right'></i>
                    </button>
                </div>
                <span>{label}</span>
                <Spinner size={25} loading={loading} />
            </div>
            <div className='option-bar'>
                <div className='view-type-buttons'>
                    <button 
                        className={view === Views.MONTH ? 'selected' : undefined}
                        onClick={() => onViewChange(Views.MONTH)}>
                        {translate(t, 'calendar.TR_MONTHLY_LABEL')}
                    </button>
                    <button
                        className={view === Views.WEEK ? 'selected' : undefined}
                        onClick={() => onViewChange(Views.WEEK)}>
                        {translate(t, 'calendar.TR_WEEKLY_LABEL')}
                    </button>
                </div>
                <button onClick={onCreate} className='create-button'>
                    <i className='fa fa-plus'></i>
                    {translate(t, 'calendar.TR_CREATE_LABEL')}
                </button>
            </div>
        </div>
    )
}